import classNames from 'classnames';
import { PartiallyRequiredProps } from './types';

function PartiallyRequiredWrapper({
	partiallyRequired,
	partiallyRequiredFilled,
	className,
	invalid,
	children,
	partiallyRequiredClass,
}: PartiallyRequiredProps) {
	const rootClasses = classNames(className, {
		[partiallyRequiredClass]: !invalid && partiallyRequired && !partiallyRequiredFilled,
	});

	return children({
		wrapperClassName: rootClasses,
	});
}

export { PartiallyRequiredWrapper };
